import './CallButton.scss';
import React from 'react';
import { Phone } from './Icons';

/** Floating click-to-call pill, bottom-left. */
export function CallButton() {
  return (
    <a className="call-fab" href="tel:+16043655225" aria-label="Click to call (604) 365-5225">
      <span className="call-fab__icon">
        <Phone />
      </span>
      <span className="call-fab__text">
        <small>Click to call</small>
        <strong>(604) 365-5225</strong>
      </span>
    </a>
  );
}
